<ng-container *ngIf="!isShowVisualizer">
<div class="row" *ngIf="!isFromModernize">
  <div class="col-12">
    <p-toolbar>
      <div class="p-toolbar-group-start pl-1">
        <div class="page-title ml-2">
          <vb-page-header></vb-page-header>
        </div>
      </div>
      <div class="p-toolbar-group-end" *ngIf="isBetaAccessPrivilegeConsumable">
        <div class="view-toggle-group">
          <button
            class="view-toggle-btn"
            [class.active]="pageViewMode === 'list'"
            (click)="switchPageView('list')"
            pTooltip="List View"
            tooltipPosition="bottom"
            aria-label="Switch to list view"
          >
            <i class="pi pi-list"></i>
          </button>
          <button
            class="view-toggle-btn"
            [class.active]="pageViewMode === 'tiles'"
            (click)="switchPageView('tiles')"
            pTooltip="Tiles View"
            tooltipPosition="bottom"
            aria-label="Switch to tiles view"
          >
            <i class="pi pi-th-large"></i>
          </button>
        </div>
      </div>
    </p-toolbar>
  </div>
</div>
<div class="main-card screens card eva-v2-page-design" *ngIf="pageViewMode === 'list'" [class.from-modernize]="isFromModernize" [class.beta-access-enabled]="isBetaAccessPrivilegeConsumable" [class.mb-3]="!isBetaAccessPrivilegeConsumable">
  <div class="card-body">
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-12"
          [ngClass]="{ 'hide-designer': isShowVisualizer, 'slide-in-left': isSlideInLeft }"
          pageheight
        >
          <p-splitter
            [panelSizes]="panelSizes"
            [minSizes]="[30, 30, 40]"
            stateStorage="local"
            #splitter
            (onResizeSart)="resizeStartHandler($event)"
            (onResizeEnd)="resizeEndHandler($event)"
            styleClass="p-splitter"
          >
            <ng-template #panel>
              <div class="tree-container">
                <div class="row screens-header table-header m-0">
                  <div class="header d-flex">
                    <span>
                      {{ 'PAGES' | translate }}
                    </span>
                  </div>
                  <div class="btn-container" [class.beta-pages-actions]="isBetaAccessPrivilegeConsumable">
                    <div class="formgroup-inline searchbox-button" [class.beta-pages-search]="isBetaAccessPrivilegeConsumable">
                      <div class="field">
                        <div class="p-inputgroup" [class.beta-pages-search-input]="isBetaAccessPrivilegeConsumable">
                          <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                          <input
                            type="text"
                            pInputText
                            placeholder="Search"
                            [(ngModel)]="searchTerm"
                            [ngModelOptions]="{ standalone: true }"
                          />
                          <span
                            class="p-inputgroup-addon"
                            [class.search-clear-addon]="isBetaAccessPrivilegeConsumable"
                            *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
                            (click)="clearFilter('pages')"
                            (keydown)="$event.key === 'Enter' && clearFilter('pages')"
                            tabindex="0"
                            role="button"
                            aria-label="Clear search"
                            ><i class="pi pi-times"></i
                          ></span>
                        </div>
                      </div>
                    </div>

                    <p-splitbutton
                      #btn
                      [model]="items"
                      [label]="isBetaAccessPrivilegeConsumable ? 'Add' : ''"
                      [icon]="isBetaAccessPrivilegeConsumable ? 'pi pi-plus' : 'pi pi-plus-circle'"
                      *ngIf="!disallowEdit && !isFromModernize"
                      (onClick)="openDropdownMenu(btn, $event)"
                      styleClass="p-button-text"
                      [ngClass]="{'add-btn page-dropdwon btn-align-right': true, 'beta-add-btn': isBetaAccessPrivilegeConsumable, 'beta-pages-add-btn': isBetaAccessPrivilegeConsumable}"
                      [disabled]="isLoadingScreens"
                    >
                    </p-splitbutton>
                  </div>
                </div>
                <div class="inner-content-container">
                  <p-contextmenu #ctxtmenu [model]="ctxtItems" appendTo="body" styleClass="screens-context-menu"></p-contextmenu>
                  <ul class="list-group list-group-sm list-group-flush screens-list">
                    <li
                      class="page-cate"
                      [class.collapsed]="!showDefaultPages"
                      (click)="showDefaultPages = !showDefaultPages"
                      (keydown)="$event.key === 'Enter' && (showDefaultPages = !showDefaultPages)"
                      tabindex="0"
                      role="button"
                      [attr.aria-expanded]="showDefaultPages"
                      aria-label="Toggle system pages"
                    >
                      {{ 'SYSTEM' | translate }} <svg-icon src="assets\images\svg\icon_down_arrow.svg"></svg-icon>
                    </li>
                    <ng-container *ngIf="!isFromModernize">
                      <ng-container *ngIf="showDefaultPages">
                      <li
                        class="list-group-item"
                        *ngFor="
                          let screen of allSelectedScreens.sysGenScreens
                            | uiFilter: searchTerm : ['pageName', 'pageType', 'tableName']
                        "
                        (click)="loadStructure($event, screen, 'screen')"
                        (keydown)="$event.key === 'Enter' && loadStructure($event, screen, 'screen')"
                        [ngClass]="{ active: screen?.sid === currentSelectedItem?.sid }"
                        showDelay="100"
                        hideDelay="100"
                        pTooltip="{{ screen.pageName }} : Table - {{
                          tableIdMap?.[screen.tableId] || screen.tableName
                        }}"
                        tooltipPosition="bottom"
                        [tooltipDisabled]="
                          screen.pageType === 'appNavigation' || screen.pageType === 'homePage' || screen.landingPage
                            ? true
                            : false
                        "
                        tabindex="0"
                        role="button"
                      >
                        <p
                          class="main"
                          [ngClass]="screen.pageType"
                          #cm
                          (contextmenu)="showLandingPageMenu($event, screen)"
                        >
                          <span *ngIf="screen.pageType === 'appNavigation'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/menu-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'homePage'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/icon_landingpage_new.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'detail'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-06.svg' : 'assets/images/svg/icon_incident_details.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'list'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/list.svg' : 'assets/images/svg/icon_user_list.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'custom'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/layout-grid-01.svg' : 'assets/images/svg/icon_user_list.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'blank'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"></svg-icon>
                          </span>
                          <span class="page-name">{{ screen.pageName || screen.tableName }}</span>
                          <span
                            *ngIf="screen.landingPage"
                            class="icon-landing"
                            [pTooltip]="'DEFAULT_LANDING_PAGE' | translate"
                            tooltipPosition="bottom"
                          >
                            <svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/landing_page.svg'"
                              (mouseenter)="onMouseEnterHomePageSvg()"
                              (mouseleave)="onMouseLeaveHomePageSvg()"
                            ></svg-icon>
                          </span>
                          <span class="delete-screen"></span>
                        </p>
                        <span class="context-menu-wrapper" *ngIf="!screen.landingPage">
                          <div class="contextMenu">
                            <button
                              class="btn btn-secondary toggle-button p-button-icon-only"
                              type="button"
                              (click)="showLandingPageMenu($event, screen); $event.stopPropagation()"
                            >
                              <span class="pi pi-ellipsis-v p-button-icon ng-star-inserted" aria-hidden="true"></span>
                            </button>
                          </div>
                        </span>
                      </li>
                      </ng-container>
                    </ng-container>
                    <ng-container *ngIf="isFromModernize && showDefaultPages">
                      <li
                        class="list-group-item"
                        *ngFor="
                          let screen of allSelectedScreens.sysGenScreens
                            | uiFilter: searchTerm : ['pageName', 'pageType', 'tableName']
                        "
                        (click)="loadStructure($event, screen, 'screen')"
                        (keydown)="$event.key === 'Enter' && loadStructure($event, screen, 'screen')"
                        [ngClass]="{ active: screen?.sid === currentSelectedItem?.sid }"
                        tabindex="0"
                        role="button"
                      >
                        <p class="main" [ngClass]="screen.pageType">
                          <span *ngIf="screen.pageType === 'appNavigation'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/menu-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"></svg-icon>
                          </span>
                          <span class="page-name">{{ screen.pageName }}</span>
                        </p>
                      </li>
                    </ng-container>
                    <li
                      class="page-cate"
                      [class.collapsed]="!showCustomPages"
                      (click)="showCustomPages = !showCustomPages"
                      (keydown)="$event.key === 'Enter' && (showCustomPages = !showCustomPages)"
                      tabindex="0"
                      role="button"
                      [attr.aria-expanded]="showCustomPages"
                      aria-label="Toggle custom pages"
                    >
                      {{ 'APPLICATION' | translate }} <svg-icon src="assets\images\svg\icon_down_arrow.svg"></svg-icon>
                    </li>
                    <ng-container *ngIf="showCustomPages">
                      <div class="spinner-container pages-spinner" *ngIf="isFromModernize && isLoadingPagesList">
                        <p-progress-spinner></p-progress-spinner>
                      </div>
                      <li
                        class="list-group-item user-gen-screens"
                        *ngFor="
                          let screen of allSelectedScreens.userGenScreens
                            | uiFilter: searchTerm : ['pageName', 'pageType', 'tableName']
                        "
                        (click)="loadStructure($event, screen, 'screen')"
                        (keydown)="$event.key === 'Enter' && loadStructure($event, screen, 'screen')"
                        [ngClass]="{ active: screen?.sid === currentSelectedItem?.sid }"
                        showDelay="100"
                        hideDelay="100"
                        pTooltip="{{ screen.pageName }} : Table - {{
                          tableIdMap?.[screen.tableId] || screen.tableName
                        }}"
                        tooltipPosition="bottom"
                        [tooltipDisabled]="screen.pageType === 'appNavigation' || screen.pageType === 'homePage'"
                        tabindex="0"
                        role="button"
                      >
                        <p
                          class="main"
                          [ngClass]="screen.pageType"
                          #cm1
                          (contextmenu)="showLandingPageMenu($event, screen)"
                        >
                          <span *ngIf="screen.pageType === 'appNavigation'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/menu-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'homePage'">
                            <svg-icon #homePageSvg [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/icon_landingpage_new.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'detail'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-06.svg' : 'assets/images/svg/icon_incident_details.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'list'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/list.svg' : 'assets/images/svg/icon_user_list.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'custom'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/layout-grid-01.svg' : 'assets/images/svg/icon_user_list.svg'"></svg-icon>
                          </span>
                          <span *ngIf="screen.pageType === 'blank'">
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"></svg-icon>
                          </span>
                          <span class="page-name" [class.landing-name]="screen.landingPage">{{ screen.pageName }}</span>
                          <span
                            class="landing-page-icon icon-landing sys-false"
                            [pTooltip]="'DEFAULT_LANDING_PAGE' | translate"
                            tooltipPosition="bottom"
                            *ngIf="screen.landingPage"
                          >
                            <svg-icon [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/landing_page.svg'" class="svg-icon"></svg-icon>
                          </span>
                          <p-button
                            styleClass="p-button-rounded p-button-outlined screens-action-btn where-used-icon-for-overlay"
                            (click)="showWhereUsed($event, screen)"
                            pTooltip="{{ 'WHERE_USED' | translate }}"
                            tooltipPosition="top"
                            *ngIf="!disallowEdit && !isFromModernize"
                          >
                            <svg-icon [src]="svgPaths.whereUsed.default"></svg-icon>
                          </p-button>
                          <p-button
                            [icon]="isBetaAccessPrivilegeConsumable ? '' : 'pi pi-pencil'"
                            styleClass="p-button-sm p-button-rounded p-button-outlined screens-action-btn"
                            (onClick)="editScreen($event, screen)"
                            showDelay="100"
                            hideDelay="100"
                            pTooltip="Edit"
                            tooltipPosition="top"
                            tooltipStyleClass="action-tooltip"
                            *ngIf="!disallowEdit && !isFromModernize"
                          >
                            <svg-icon *ngIf="isBetaAccessPrivilegeConsumable" src="assets/designIconLib/SVG/edit-05.svg" class="beta-action-icon"></svg-icon>
                          </p-button>
                          <p-button
                            [icon]="isBetaAccessPrivilegeConsumable ? '' : 'pi pi-trash'"
                            styleClass="p-button-sm p-button-rounded p-button-outlined mr-3 screens-action-btn"
                            (onClick)="deleteScreen($event, screen)"
                            showDelay="100"
                            hideDelay="100"
                            pTooltip="Delete"
                            tooltipPosition="top"
                            tooltipStyleClass="action-tooltip"
                            *ngIf="!disallowEdit && (!isFromModernize || (screen.pageType !== 'appNavigation' && !modernizeReadOnly))"
                          >
                            <svg-icon *ngIf="isBetaAccessPrivilegeConsumable" src="assets/designIconLib/SVG/trash-01.svg" class="beta-action-icon color-red"></svg-icon>
                          </p-button>
                        </p>

                        <span class="context-menu-wrapper" *ngIf="!isFromModernize && !screen.landingPage">
                          <div class="contextMenu">
                            <button
                              class="btn btn-secondary toggle-button p-button-icon-only"
                              type="button"
                              (click)="showLandingPageMenu($event, screen); $event.stopPropagation()"
                            >
                              <span class="pi pi-ellipsis-v p-button-icon ng-star-inserted" aria-hidden="true"></span>
                            </button>
                          </div>
                        </span>
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
            </ng-template>
            <ng-template #panel>
              <div class="layout-container page-design">
                <div class="screens-header table-header">
                  <div class="table-title header">
                    <svg-icon src="assets\images\svg\icon_page_design.svg"></svg-icon>
                    <span
                      pTooltip="{{ ('PAGE_DESIGN' | translate) + (currentSelectedItem ? ' : ' + currentSelectedItem.pageName : '') }}"
                      tooltipPosition="bottom"
                    >
                      {{ 'PAGE_DESIGN' | translate }}
                      {{ currentSelectedItem ? ' : ' + currentSelectedItem.pageName : '' }}
                    </span>
                  </div>
                  <div class="formgroup-inline searchbox-button">
                    <div class="field">
                      <div class="p-inputgroup">
                        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                        <input
                          type="text"
                          pInputText
                          placeholder="Search"
                          (keyup)="filterTree($event)"
                          [(ngModel)]="pageDesignSearchTerm"
                          (search)="filterTree($event)"
                        />
                        <span
                          class="p-inputgroup-addon"
                          *ngIf="
                            pageDesignSearchTerm !== '' &&
                            pageDesignSearchTerm !== undefined &&
                            pageDesignSearchTerm !== null
                          "
                          (click)="clearFilter('pagedesign')"
                          (keydown)="$event.key === 'Enter' && clearFilter('pagedesign')"
                          tabindex="0"
                          role="button"
                          aria-label="Clear page design search"
                          ><i class="pi pi-times"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inner-content-container pagedesigns">
                  <table id="screensTree-list" class="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="context-menu-td">
                          <div class="dropdown contextMenu">
                            <p-button
                              class="btn dropdown-toggle toggle-button hidden"
                              icon="pi pi-ellipsis-v"
                              type="button"
                              [disabled]="disallowEdit"
                              id="context-menu-trigger-list"
                            />
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-template>
            <ng-template #panel>
              <div class="layout-container temp-layout-container screen-prop-pane" [class.prop-pane-disabled]="isFromModernize && modernizeReadOnly">
                <vb-properties-pane
                  class="properties-pane"
                  [style]="{ width: '100%' }"
                  [currentSelectedTreeNode]="currentSelectedTreeNode"
                  [pageName]="'pages'"
                  [currentScreen]="currentSelectedItem"
                  [iconSize]="iconSize"
                  [currentPicklist]="currentPicklist"
                  [selectedPropertyTitle]="selectedNodeTitle"
                  [selectedNodeType]="currentSelectedTreeNode?.type"
                  [currentTable]="tblProps"
                  [seletedTemplate]="seletedTemplate"
                  *ngIf="selectedNodeTitle"
                  [isFromModernize]="isFromModernize"
                ></vb-properties-pane>
                <div *ngIf="!selectedNodeTitle" class="no-prop-text">
                  Please click on the row to see the properties.
                </div>
              </div>
            </ng-template>
          </p-splitter>
          <div class="spinner-container" *ngIf="isLoadingScreens">
            <p-progress-spinner></p-progress-spinner>
          </div>
        </div>
        <div
          class="col-12 visualizer-container"
          [ngClass]="{ 'show-visualizer': isShowVisualizer }"
          pageheight
          style="position: relative"
        >
          <div
            #prototypeOutput
            (mouseover)="adjustPanelSizes('in')"
            (mouseleave)="adjustPanelSizes('out')"
            (focus)="adjustPanelSizes('in')"
            (blur)="adjustPanelSizes('out')"
            id="prototypeOutput-list"
            style="position: relative"
            tabindex="0"
          >
            <!-- Commenting iframe related changes which is no longer used as part of sonar security issues -->
            <!-- <div *ngIf="!iframeSource" class="loadingText">{{ 'LOADING_PROTOTYPE' | translate }}</div>
            <iframe [attr.src]="iframeSource" id="protoIframe-list" title="Prototype Preview" *ngIf="iframeSource"></iframe> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="main-card screens mb-3 card eva-v2-page-design"
  [class.is-page-list]="!isDesigningScreen"
  [class.is-page-detail]="isDesigningScreen"
  [class.beta-access-enabled]="isBetaAccessPrivilegeConsumable"
  *ngIf="pageViewMode === 'tiles' && isBetaAccessPrivilegeConsumable"
>
  <div class="card-body">
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-12"
          [ngClass]="{ 'hide-designer': isShowVisualizer, 'slide-in-left': isSlideInLeft }"
          pageheight
        >
          <!-- Pane 1: Pages List (Screen 1) -->
          <div *ngIf="!isDesigningScreen" class="card-container">
            <div class="tree-container tree-container-wrapper" [class.h-100]="isBetaAccessPrivilegeConsumable">
              <div class="row screens-header table-header m-0">
                <div class="header d-flex visibility-hidden">
                  <svg-icon src="assets\images\svg\icon_pages.svg"></svg-icon>
                  <span>
                    {{ 'PAGES' | translate }}
                  </span>
                </div>
                <div class="btn-container" [class.beta-pages-actions]="isBetaAccessPrivilegeConsumable">
                  <div class="formgroup-inline searchbox-button" [class.beta-pages-search]="isBetaAccessPrivilegeConsumable">
                    <div class="field">
                      <div class="p-inputgroup" [class.beta-pages-search-input]="isBetaAccessPrivilegeConsumable">
                        <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                        <input
                          type="text"
                          pInputText
                          placeholder="Search"
                          [(ngModel)]="searchTerm"
                          [ngModelOptions]="{ standalone: true }"
                        />
                        <span
                          class="p-inputgroup-addon"
                          [class.search-clear-addon]="isBetaAccessPrivilegeConsumable"
                          *ngIf="searchTerm !== '' && searchTerm !== undefined && searchTerm !== null"
                          (click)="clearFilter('pages')"
                          (keydown)="$event.key === 'Enter' && clearFilter('pages')"
                          tabindex="0"
                          role="button"
                          aria-label="Clear search"
                          ><i class="pi pi-times"></i
                        ></span>
                      </div>
                    </div>
                  </div>

                  <p-splitbutton
                    #btn
                    [model]="items"
                    [label]="isBetaAccessPrivilegeConsumable ? 'Add' : ''"
                    [icon]="isBetaAccessPrivilegeConsumable ? 'pi pi-plus' : 'pi pi-plus-circle'"
                    *ngIf="!disallowEdit && !isFromModernize"
                    (onClick)="openDropdownMenu(btn, $event)"
                    styleClass="p-button-text"
                    [ngClass]="{'add-btn page-dropdwon btn-align-right': true, 'beta-add-btn': isBetaAccessPrivilegeConsumable, 'beta-pages-add-btn': isBetaAccessPrivilegeConsumable}"
                    [disabled]="isLoadingScreens"
                  >
                  </p-splitbutton>
                </div>
              </div>
              <div class="inner-content-container p-4 overflow-auto page-list">
                <!-- SYSTEM PAGES HEADER -->
                <div
                  class="page-cate d-flex align-items-center mb-1"
                  [class.collapsed]="!showDefaultPages"
                  (click)="showDefaultPages = !showDefaultPages"
                  (keydown)="$event.key === 'Enter' && (showDefaultPages = !showDefaultPages)"
                  tabindex="0"
                  role="button"
                  [attr.aria-expanded]="showDefaultPages"
                  aria-label="Toggle system pages"
                >
                  <h6 class="m-0 text-muted">{{ 'System' | translate }}</h6>
                  <svg-icon src="assets\images\svg\icon_down_arrow.svg" class="ml-2 icon_down_arrow"></svg-icon>
                </div>

                <p-contextmenu #ctxtmenu [model]="ctxtItems" appendTo="body" styleClass="screens-context-menu" *ngIf="!disallowEdit"> </p-contextmenu>

                <!-- SYSTEM PAGES TILES -->
                <div class="row mb-2 p-0" *ngIf="showDefaultPages" style="gap: 15px">
                  <div
                    class="d-flex flex-column align-items-center"
                    style="width: 140px"
                    *ngFor="
                      let screen of allSelectedScreens.sysGenScreens
                        | uiFilter: searchTerm : ['pageName', 'pageType', 'tableName']
                    "
                  >
                    <div
                      class="card shadow-sm page-tile-card mb-2 position-relative page-type {{ screen.pageType }}"
                      (click)="loadStructure($event, screen, 'screen')"
                      (keydown)="$event.key === 'Enter' && loadStructure($event, screen, 'screen')"
                      [ngClass]="{ 'border-primary': screen?.sid === currentSelectedItem?.sid }"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="{{ screen.pageName }} : Table - {{ tableIdMap?.[screen.tableId] || screen.tableName }}"
                      tooltipPosition="bottom"
                      [tooltipDisabled]="
                        screen.pageType === 'appNavigation' || screen.pageType === 'homePage' || screen.landingPage
                          ? true
                          : false
                      "
                      tabindex="0"
                      role="button"
                    >
                      <!-- Top Right Context Menu moved to app-name -->

                      <!-- Top Left Landing Badge -->
                      <div
                        class="position-absolute landing-badge"
                        *ngIf="screen.landingPage"
                        [pTooltip]="'DEFAULT_LANDING_PAGE' | translate"
                      >
                        <svg-icon
                          [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/landing_page.svg'"
                          (mouseenter)="onMouseEnterHomePageSvg()"
                          (mouseleave)="onMouseLeaveHomePageSvg()"
                          [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
                        ></svg-icon>
                      </div>

                      <div
                        class="card-body d-flex flex-column align-items-center justify-content-center p-0 h-100"
                        #cm
                        (contextmenu)="getContextMenuItems($event, screen)"
                      >
                        <!-- Page Type Icon -->
                        <div class="page-item-icon">
                          <span *ngIf="screen.pageType === 'appNavigation'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/menu-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'homePage'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/icon_landingpage_new.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'detail'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-06.svg' : 'assets/images/svg/icon_incident_details.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'list'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/list.svg' : 'assets/images/svg/icon-applist.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'custom'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/layout-grid-01.svg' : 'assets/images/svg/icon_user_list.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'blank'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                        </div>
                      </div>
                    </div>

                    <!-- External Page Name -->
                    <div class="d-flex align-items-center justify-content-between mt-1 page-name">
                      <h6
                        class="text-left mb-0 text-truncate page-tile-title"
                        [ngClass]="{ 'text-primary font-weight-bold': screen?.sid === currentSelectedItem?.sid }"
                        pTooltip="{{ screen.pageName || screen.tableName }}"
                        tooltipPosition="bottom"
                      >
                        {{ screen.pageName || screen.tableName }}
                      </h6>
                      <div class="contextMenu page-tile-dropdown ml-auto" *ngIf="!disallowEdit && hasTilesMenuItems(screen)">
                        <button
                          class="btn btn-sm btn-link text-muted p-1 hide-dropdown-arrow"
                          type="button"
                          (click)="showLandingPageMenu($event, screen); $event.stopPropagation()"
                          [attr.aria-label]="'Open page actions menu'"
                        >
                          <i class="pi pi-ellipsis-v"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- APPLICATION PAGES HEADER -->
                <div
                  class="page-cate d-flex align-items-center mb-1"
                  [class.collapsed]="!showCustomPages"
                  (click)="showCustomPages = !showCustomPages"
                  (keydown)="$event.key === 'Enter' && (showCustomPages = !showCustomPages)"
                  tabindex="0"
                  role="button"
                  [attr.aria-expanded]="showCustomPages"
                  aria-label="Toggle custom pages"
                >
                  <h6 class="m-0 text-muted">{{ 'Application' | translate }}</h6>
                  <svg-icon src="assets\images\svg\icon_down_arrow.svg" class="ml-2 icon_down_arrow"></svg-icon>
                </div>

                <!-- APPLICATION PAGES TILES -->
                <div class="row pb-1 p-0 mb-3" *ngIf="showCustomPages" style="gap: 15px">
                  <div
                    class="d-flex flex-column align-items-center"
                    style="width: 140px"
                    *ngFor="
                      let screen of allSelectedScreens.userGenScreens
                        | uiFilter: searchTerm : ['pageName', 'pageType', 'tableName']
                    "
                  >
                    <div
                      class="card shadow-sm page-tile-card mb-2 position-relative page-type {{ screen.pageType }}"
                      (click)="loadStructure($event, screen, 'screen')"
                      (keydown)="$event.key === 'Enter' && loadStructure($event, screen, 'screen')"
                      [ngClass]="{ 'border-primary': screen?.sid === currentSelectedItem?.sid }"
                      showDelay="100"
                      hideDelay="100"
                      pTooltip="{{ screen.pageName }} : Table - {{ tableIdMap?.[screen.tableId] || screen.tableName }}"
                      tooltipPosition="bottom"
                      [tooltipDisabled]="screen.pageType === 'appNavigation' || screen.pageType === 'homePage'"
                      tabindex="0"
                      role="button"
                    >
                      <!-- Top Right Context Menu moved to app-name -->

                      <!-- Top Left Landing Badge -->
                      <div
                        class="position-absolute landing-badge"
                        *ngIf="screen.landingPage"
                        [pTooltip]="'DEFAULT_LANDING_PAGE' | translate"
                      >
                        <svg-icon
                          [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/landing_page.svg'"
                          [svgStyle]="{ 'width.px': 20, 'height.px': 20 }"
                        ></svg-icon>
                      </div>

                      <div
                        class="card-body d-flex flex-column align-items-center justify-content-center p-4 pb-3 h-100"
                        #cm1
                        (contextmenu)="getContextMenuItems($event, screen)"
                      >
                        <!-- Page Type Icon -->
                        <div class="page-item-icon mb-3 mt-1">
                          <span *ngIf="screen.pageType === 'appNavigation'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/menu-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'homePage'"
                            ><svg-icon
                              #homePageSvg
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/home-line.svg' : 'assets/images/svg/icon_landingpage_new.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'detail'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-06.svg' : 'assets/images/svg/icon_incident_details.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'list'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/list.svg' : 'assets/images/svg/icon-applist.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'custom'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/layout-grid-01.svg' : 'assets/images/svg/icon_user_list.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                          <span *ngIf="screen.pageType === 'blank'"
                            ><svg-icon
                              [src]="isBetaAccessPrivilegeConsumable ? 'assets/designIconLib/SVG/file-01.svg' : 'assets/images/svg/icon_app_navigation.svg'"
                              [svgStyle]="{ 'width.px': 45, 'height.px': 45 }"
                            ></svg-icon
                          ></span>
                        </div>
                      </div>
                    </div>

                    <!-- External Page Name -->
                    <div class="d-flex align-items-center justify-content-between mt-1 page-name">
                      <h6
                        class="text-left mb-0 text-truncate page-tile-title"
                        [ngClass]="{ 'text-primary font-weight-bold': screen?.sid === currentSelectedItem?.sid }"
                        pTooltip="{{ screen.pageName }}"
                        tooltipPosition="bottom"
                      >
                        {{ screen.pageName }}
                      </h6>
                      <div class="contextMenu page-tile-dropdown ml-auto" *ngIf="!disallowEdit && hasTilesMenuItems(screen)">
                        <button
                          class="btn btn-sm btn-link text-muted p-1 hide-dropdown-arrow"
                          type="button"
                          (click)="showLandingPageMenu($event, screen); $event.stopPropagation()"
                          [attr.aria-label]="'Open page actions menu'"
                        >
                          <i class="pi pi-ellipsis-v"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pane 2 & 3: Designer & Properties (Screen 2) -->
          <div *ngIf="isDesigningScreen" class="h-100 flex-column d-flex">
            <div
              class="back-btn-container py-2 m-0 bg-white border-bottom pl-2 d-flex align-items-center"
              style="border: 1px solid #dee2e6; border-bottom: none; border-radius: 4px 4px 0 0"
            >
              <p-button
                icon="pi pi-arrow-left"
                label="{{ 'Go Back to Pages' | translate }}"
                styleClass="p-button-text p-button-sm m-0 p-1 button-filled"
                (onClick)="goBackToPagesList()"
              ></p-button>
              <span class="ml-3 font-weight-bold" *ngIf="currentSelectedItem">{{ currentSelectedItem.pageName }}</span>
            </div>

            <p-splitter
              [panelSizes]="[50, 50]"
              [minSizes]="[30, 30]"
              stateStorage="local"
              #splitter
              (onResizeSart)="resizeStartHandler($event)"
              (onResizeEnd)="resizeEndHandler($event)"
              styleClass="p-splitter h-100"
              style="border-radius: 0 0 4px 4px"
            >
              <ng-template #panel>
                <div class="layout-container page-design">
                  <div class="screens-header table-header">
                    <div class="table-title header">
                      <svg-icon src="assets\images\svg\icon_page_design.svg"></svg-icon>
                      <span
                        pTooltip="{{ ('PAGE_DESIGN' | translate) + (currentSelectedItem ? ' : ' + currentSelectedItem.pageName : '') }}"
                        tooltipPosition="bottom"
                      >
                        {{ 'PAGE_DESIGN' | translate }}
                        {{ currentSelectedItem ? ' : ' + currentSelectedItem.pageName : '' }}
                      </span>
                    </div>
                    <div class="formgroup-inline searchbox-button">
                      <div class="field">
                        <div class="p-inputgroup">
                          <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
                          <input
                            type="text"
                            pInputText
                            placeholder="Search"
                            (keyup)="filterTree($event)"
                            [(ngModel)]="pageDesignSearchTerm"
                            (search)="filterTree($event)"
                          />
                          <span
                            class="p-inputgroup-addon"
                            *ngIf="
                              pageDesignSearchTerm !== '' &&
                              pageDesignSearchTerm !== undefined &&
                              pageDesignSearchTerm !== null
                            "
                            (click)="clearFilter('pagedesign')"
                            (keydown)="$event.key === 'Enter' && clearFilter('pagedesign')"
                            tabindex="0"
                            role="button"
                            aria-label="Clear page design search"
                            ><i class="pi pi-times"></i
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="inner-content-container pagedesigns">
                    <table id="screensTree-pane" class="table">
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td></td>
                          <td></td>
                          <td></td>
                          <td class="context-menu-td">
                            <div class="dropdown contextMenu">
                              <p-button
                                class="btn dropdown-toggle toggle-button hidden"
                                icon="pi pi-ellipsis-v"
                                type="button"
                                [disabled]="disallowEdit"
                                id="context-menu-trigger-pane"
                              />
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </ng-template>
              <ng-template #panel>
                <div class="layout-container temp-layout-container screen-prop-pane">
                  <vb-properties-pane
                    class="properties-pane"
                    [style]="{ width: '100%' }"
                    [currentSelectedTreeNode]="currentSelectedTreeNode"
                    [pageName]="'pages'"
                    [currentScreen]="currentSelectedItem"
                    [iconSize]="iconSize"
                    [currentPicklist]="currentPicklist"
                    [selectedPropertyTitle]="selectedNodeTitle"
                    [selectedNodeType]="currentSelectedTreeNode?.type"
                    [currentTable]="tblProps"
                    [seletedTemplate]="seletedTemplate"
                    *ngIf="selectedNodeTitle"
                  ></vb-properties-pane>
                  <div *ngIf="!selectedNodeTitle" class="no-prop-text">
                    Please click on the row to see the properties.
                  </div>
                </div>
              </ng-template>
            </p-splitter>
          </div>

          <div class="spinner-container" *ngIf="isLoadingScreens">
            <p-progress-spinner></p-progress-spinner>
          </div>
        </div>
        <div
          class="col-12 visualizer-container"
          [ngClass]="{ 'show-visualizer': isShowVisualizer }"
          pageheight
          style="position: relative"
        >
          <div
            #prototypeOutput
            (mouseover)="adjustPanelSizes('in')"
            (mouseleave)="adjustPanelSizes('out')"
            (focus)="adjustPanelSizes('in')"
            (blur)="adjustPanelSizes('out')"
            id="prototypeOutput-pane"
            style="position: relative"
            tabindex="0"
          >
            <!-- Commenting iframe related changes which is no longer used as part of sonar security issues -->
            <!-- <div *ngIf="!iframeSource" class="loadingText">{{ 'LOADING_PROTOTYPE' | translate }}</div>
            <iframe [attr.src]="iframeSource" id="protoIframe-pane" title="Prototype Preview" *ngIf="iframeSource"></iframe> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog
  header="{{ 'GENERATE_SCREENS' | translate }}"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'screens-modal-popup eva-v2-generate-page-design beta-access-enabled' : 'screens-modal-popup eva-v2-generate-page-design'"
  [(visible)]="showCreateScreensModal"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '50vw' }"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
>
  <div class="mb-2">
    <p-accordion [multiple]="true" [value]="[0, 1]">
      <p-accordion-panel [value]="0">
        <p-accordion-header>Yet to be generated</p-accordion-header>
        <p-accordion-content>
          <div class="section-table-container mb-2">
            <p-table
              [columns]="cols"
              [value]="allTablesSplitted.pending"
              dataKey="tableId"
              responsiveLayout="scroll"
              styleClass="p-datatable-sm"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns">
                    {{ col.header | translate }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-table let-columns="columns">
                <tr>
                  <td>
                    {{ table.tableName }}
                  </td>
                  <td pEditableColumn>
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="table.lpNeeded"
                      [attr.name]="table.lpNeeded"
                      [readonly]="table.lpNeeded && !table.temp_lpNeeded"
                      [ngClass]="{ readOnly: table.lpNeeded && !table.temp_lpNeeded }"
                      *ngIf="
                        table.tableType !== dmconstants.QUERY_VIEW ||
                        (table.tableType === dmconstants.QUERY_VIEW && table.queryType !== dmconstants.SINGLE_QUERY)
                      "
                      (onChange)="handleSelectionChange($event, table, 'lpNeeded')"
                    ></p-checkbox>
                  </td>
                  <td pEditableColumn>
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="table.dpNeeded"
                      [attr.name]="table.dpNeeded"
                      [readonly]="table.dpNeeded && !table.temp_dpNeeded"
                      [ngClass]="{ readOnly: table.dpNeeded && !table.temp_dpNeeded }"
                      *ngIf="
                        table.tableType !== dmconstants.QUERY_VIEW ||
                        (table.tableType === dmconstants.QUERY_VIEW &&
                          (table.queryType === dmconstants.SINGLE_QUERY ||
                            (table.queryType === dmconstants.MULTIPLE_QUERY && table.createDetailPage)))
                      "
                      (onChange)="handleSelectionChange($event, table, 'dpNeeded')"
                    >
                    </p-checkbox>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage" let-columns>
                <tr class="no-records">
                  <td colspan="3" class="text-center">
                    {{ 'NO_RECORDS_FOUND' | translate }}
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isModalLoader">
            <div class="spinners">
              <p-progress-spinner></p-progress-spinner>
            </div>
          </div>
        </p-accordion-content>
      </p-accordion-panel>

      <p-accordion-panel [value]="1">
        <p-accordion-header>Generated</p-accordion-header>
        <p-accordion-content>
          <div class="section-table-container">
            <p-table
              [columns]="cols"
              [value]="allTablesSplitted.generated"
              dataKey="tableId"
              responsiveLayout="scroll"
              styleClass="p-datatable-sm"
            >
              <ng-template pTemplate="header" let-columns>
                <tr>
                  <th *ngFor="let col of columns">
                    {{ col.header | translate }}
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-table let-columns="columns">
                <tr>
                  <td>
                    {{ table.tableName }}
                  </td>
                  <td>
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="table.lpNeeded"
                      [attr.name]="table.lpNeeded"
                      [readonly]="table.lpNeeded && !table.temp_lpNeeded"
                      [ngClass]="{ readOnly: table.lpNeeded && !table.temp_lpNeeded }"
                      *ngIf="
                        table.tableType !== dmconstants.QUERY_VIEW ||
                        (table.tableType === dmconstants.QUERY_VIEW && table.queryType !== dmconstants.SINGLE_QUERY)
                      "
                      (onChange)="handleSelectionChange($event, table, 'lpNeeded')"
                    ></p-checkbox>
                  </td>
                  <td>
                    <p-checkbox
                      [binary]="true"
                      [(ngModel)]="table.dpNeeded"
                      [attr.name]="table.dpNeeded"
                      [readonly]="table.dpNeeded && !table.temp_dpNeeded"
                      [ngClass]="{ readOnly: table.dpNeeded && !table.temp_dpNeeded }"
                      *ngIf="
                        table.tableType !== dmconstants.QUERY_VIEW ||
                        (table.tableType === dmconstants.QUERY_VIEW &&
                          (table.queryType === dmconstants.SINGLE_QUERY ||
                            (table.queryType === dmconstants.MULTIPLE_QUERY && table.createDetailPage)))
                      "
                      (onChange)="handleSelectionChange($event, table, 'dpNeeded')"
                    >
                    </p-checkbox>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </p-accordion-content>
      </p-accordion-panel>
    </p-accordion>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="handleScreensModalClose()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" class="save-btn btn btn-primary button-filled" (click)="createScreensFromTable()"
      [disabled]="checkBoxChanged === 0">
      {{ 'GENERATE' | translate }}
    </button>
  </ng-template>
</p-dialog>
<p-dialog
  header="{{ (editScreenVal ? 'UPDATE_PAGE_NAME' : 'CREATE_SCREEN') | translate }}"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'screen-modal-popup eva-v2-generate-page-design beta-access-enabled' : 'screen-modal-popup eva-v2-generate-page-design'"
  [(visible)]="showCreateScreen"
  [modal]="true"
  [appendTo]="'body'"
  [style]="{ width: '50vw' }"
  [closable]="false"
>
  <form [formGroup]="createScreenForm" #asFg="ngForm" class="single-screen-modal-popup">
    <div class="form-group row">
      <label for="pageName" class="col-3 p-0 pt-1 mb-0 pl-1 required col-form-label">{{
        'PAGE_NAME' | translate
      }}</label>
      <div class="col-9 pl-0">
        <input
          id="pageName"
          class="form-control"
          type="text"
          formControlName="pageName"
          [ngClass]="{ 'error-border': this.messages && this.messages.pageName }"
        />
        <small *ngIf="this.messages && this.messages.pageName" class="input-error-text">
          <span [innerHtml]="this.messages.pageName"></span>
        </small>
      </div>
    </div>
    <div
      class="form-group row"
      [ngStyle]="{ visibility: createScreenForm.get('screenType')?.value === 'fromTable' ? 'visible' : 'hidden' }"
    >
      <label for="tableName" class="col-3 required col-form-label">{{ 'TABLE' | translate }}</label>
      <div class="col-9 pl-0">
        <p-autocomplete
          id="tableName"
          class=""
          formControlName="tableName"
          [suggestions]="allTablesCopy"
          field="tableName"
          (completeMethod)="searchForTable($event)"
          [dropdown]="true"
          [forceSelection]="true"
          [appendTo]="'body'"
          (onSelect)="ontblChange($event)"
          [ngClass]="{ 'error-border': this.messages && this.messages.tableName }"
        >
        </p-autocomplete>
        <small *ngIf="this.messages && this.messages.tableName" class="input-error-text">
          <span [innerHtml]="this.messages.tableName"></span>
        </small>
      </div>
    </div>
    <div class="form-group row">
      <label for="pageType" class="col-3 required col-form-label">{{ 'PAGE_TYPE' | translate }}</label>
      <div class="col-9 pl-0 mt-1 pb-2">
        <span *ngFor="let option of pageTypeOptions">
          <p-radiobutton
            formControlName="pageType"
            [value]="option.value"
            [inputId]="option.value"
            [ngClass]="{ 'error-border': this.messages && this.messages.pageType }"
          ></p-radiobutton>
          <label class="mb-0 mr-2" [for]="option.value">{{ option.name }}</label>
        </span>
        <small *ngIf="this.messages && this.messages.pageType" class="input-error-text">
          <span [innerHtml]="this.messages.pageType"></span>
        </small>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <div style="display: flex; justify-content: end">
      <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="onclose()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="submit" class="save-btn btn btn-primary button-filled" (click)="generateSelectedScreen()" *ngIf="!editScreenVal">
        {{ 'GENERATE' | translate }}
      </button>
      <button type="submit" class="save-btn btn btn-primary button-filled" (click)="updateSelectedScreen()" *ngIf="editScreenVal">
        {{ 'UPDATE' | translate }}
      </button>
    </div>
  </ng-template>
  <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoadingScreens">
    <div class="spinner-container">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="{{
    (listPageName === 'childgrid'
      ? 'ADD_CHILD_TABLE'
      : listPageName === 'queryview'
        ? 'ADD_QUERY_VIEW'
        : 'ADD_STANDARD_GRID'
    ) | translate
  }}"
  styleClass="screen-modal-popup eva-v2-generate-page-design"
  [(visible)]="showListPagesModal"
  [modal]="true"
  [draggable]="false"
  [appendTo]="'body'"
  [style]="{ width: '50vw' }"
  [closable]="false"
>
  <form class="single-screen-modal-popup">
    <div class="row form-group mt-3">
      <label for="selectedPage" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
        'PAGE' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <p-autocomplete
          id="selectedPage"
          [(ngModel)]="selectedPage"
          name="selectedPage"
          [suggestions]="listPages"
          field="pageName"
          (completeMethod)="searchForListPage($event)"
          [dropdown]="true"
          [forceSelection]="true"
          [appendTo]="'body'"
          [ngClass]="{ 'error-border': !selectedPage && submitted && errorFlag }"
        >
        </p-autocomplete>
        <small *ngIf="!selectedPage && submitted && errorFlag" class="input-error-text">
          <span [innerHtml]="errorMessage"></span>
        </small>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <div style="display: flex; justify-content: end">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeListPagesDialogue()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="save-btn btn btn-primary" (click)="addSelectedPageToNode()">
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </ng-template>
  <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoadingScreens">
    <div class="spinner-container">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="{{ 'ADD_CUSTOM_COMPONENT' | translate }}"
  styleClass="screen-modal-popup eva-v2-generate-page-design"
  [(visible)]="showCCModal"
  [modal]="true"
  [appendTo]="'body'"
  [draggable]="false"
  [style]="{ width: '50vw' }"
  [closable]="false"
>
  <form class="single-screen-modal-popup">
    <div class="row form-group mt-3">
      <label for="selectedCC" class="col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4 col-form-label required">{{
        'CUSTOM_COMPONENT' | translate
      }}</label>
      <div class="col-xs-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
        <p-autocomplete
          id="selectedCC"
          [(ngModel)]="selectedCC"
          name="childTable"
          [suggestions]="allCCs"
          field="componentName"
          (completeMethod)="searchForCC($event)"
          [dropdown]="true"
          [forceSelection]="true"
          [appendTo]="'body'"
          [ngClass]="{ 'error-border': errorFlag }"
        >
        </p-autocomplete>
        <small *ngIf="errorFlag" class="input-error-text">
          <span [innerHtml]="errorMessage"></span>
        </small>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <div style="display: flex; justify-content: end">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeCCModalDialogue()">
        {{ 'CANCEL' | translate }}
      </button>
      <button type="button" class="save-btn btn btn-primary" (click)="addSelectedCCToNode()">
        {{ 'SAVE' | translate }}
      </button>
    </div>
  </ng-template>
  <div class="d-flex justify-content-center align-items-center w-100" *ngIf="isLoadingScreens">
    <div class="spinner-container">
      <p-progress-spinner></p-progress-spinner>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="{{ 'ADD_FIELDS' | translate }}"
  styleClass="screens-modal-popup"
  [(visible)]="showAddFieldsModal"
  [modal]="true"
  [appendTo]="'body'"
  [draggable]="false"
  [style]="{ width: '50vw' }"
  [baseZIndex]="150"
  [closable]="false"
>
  <div class="search-form-control field-filter">
    <span class="search-icon">
      <i class="pi pi-search"></i>
    </span>
    <input
      type="text"
      class="form-control form-control-sm"
      placeholder="Search"
      [(ngModel)]="fieldSearch"
      (input)="referredFields?.length && searchTbl?.filterGlobal($event.target?.value, 'contains')"
    />
    <button
      *ngIf="fieldSearch !== '' && fieldSearch !== undefined && fieldSearch !== null"
      class="input-clear-icon position-absolute btn btn-link p-0"
      (click)="clearFilter('dialog')"
      type="button"
      aria-label="Clear field search"
    >
      <img src="assets\images\svg\icon_clear.svg" alt="icon clear" />
    </button>
  </div>

  <ng-container
    *ngIf="
      techStack?.textSearch === 'Elastic Search' &&
        activeScreen?.pageType === 'list' &&
        activeScreen?.pageTableType !== 'QUERY_VIEW' &&
        showAddFieldsModal &&
        referredFields.length;
      else currentTable
    "
  >
    <p-tabs [(value)]="activeTabIndex">
      <p-tablist>
        <p-tab [value]="0">Table Fields</p-tab>
        <p-tab [value]="1">Referenced Table Fields</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <ng-container *ngTemplateOutlet="currentTable"></ng-container>
        </p-tabpanel>
        <p-tabpanel [value]="1" *ngIf="referredFields.length">
          <ng-container *ngTemplateOutlet="searchFieldsTemplate"></ng-container>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </ng-container>

  <ng-template #searchFieldsTemplate>
    <div class="mt-2 mb-2 search-fld-container" #searchcontainer>
      <p-treeTable
        #searchTbl
        [columns]="referredFieldsCols"
        [value]="referredFields"
        dataKey="tableId"
        responsiveLayout="scroll"
        [scrollHeight]="'50vh'"
        [autoLayout]="true"
        id="add_key_table-list"
        [scrollable]="true"
        styleClass="p-datatable-sm eva-v2-table-container"
        (onNodeExpand)="onNodeExpand($event)"
        (onNodeCollapse)="onNodeCollapse($event)"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th class="{{ col.field }}" scope="col">
                {{ col.header | translate }}
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
          <tr class="{{ rowNode.level === 1 ? 'childLevel' : 'parentLevel' }}">
            <td class="tbl-{{ rowNode.level }} {{ 'foreignkey' }} name">
              <div class="w-100 d-flex align-items-center">
                <p-treetable-toggler [rowNode]="rowNode" *ngIf="rowData.showChild"> </p-treetable-toggler>
                <span>{{ rowData.name?.split('+')[0] }}</span>
                <span class="tabl-label" title="table">{{ rowData.name?.split('+')[1] }}</span>
                <i
                  *ngIf="rowData.mappedField"
                  class="fa fa-info-circle field-info tblInfo"
                  showDelay="100"
                  hideDelay="100"
                  tooltipPosition="bottom"
                  tooltipStyleClass="label-tooltip custom-tooltip-properties"
                  pTooltip="Only non-mapped fields can be selected for configuration."
                ></i>
                <span class="map-fld-label" *ngIf="rowData.mappedField" title="table">{{
                  fieldIdMap[rowData.mappedField]
                }}</span>
              </div>
            </td>

            <td ttEditableColumn class="addedToTable">
              <p-checkbox
                *ngIf="!rowData.showChild"
                [binary]="true"
                [(ngModel)]="rowData.addedToTable"
                [readonly]="rowData.addedToTable && !rowData.temp_addedToTable"
                [attr.name]="rowData.addedToTable"
                [disabled]="!rowData.searchable || rowData.mappedField"
                (onChange)="handleSelectionChange($event, rowData, 'addedToTable')"
              >
              </p-checkbox>
            </td>

            <td ttEditableColumn class="fkAliasName">
              <input
                *ngIf="!rowData.showChild && rowData.searchable && rowData.addedToTable"
                [(ngModel)]="rowData.fkAliasName"
                class="input-display"
                title="{{ rowData.fkAliasName }}"
                [disabled]="true"
              />
              <span *ngIf="!rowData.searchable && !rowData.showChild && !rowData.addedToTable" class="search-info-label"
                >(Not Searchable)</span
              >
            </td>
          </tr>
          <div *ngIf="isloading" class="loader">
            <p-progress-spinner></p-progress-spinner>
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr class="no-records">
            <td colspan="2" class="text-center">
              {{ 'NO_RECORDS_FOUND' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-treeTable>
    </div>
    <div *ngIf="isloading" class="d-flex justify-content-center align-items-center w-100">
      <div class="spinners">
        <p-progress-spinner></p-progress-spinner>
      </div>
    </div>
  </ng-template>
  <ng-template #currentTable>
    <h2 class="field-header" *ngIf="isRDBMS && foreignKeyData.length">Table Fields</h2>
    <div class="section-table-container mb-2">
      <p-table
        [columns]="addFieldsCols"
        [value]="allFields | uiFilter: fieldSearch : ['name']"
        dataKey="tableId"
        responsiveLayout="scroll"
        styleClass="p-datatable-sm eva-v2-table-container"
        id="add_key_table-pane"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns">
              {{ col.header | translate }}
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-table let-columns="columns">
          <tr>
            <td>
              {{ table.name }}
            </td>
            <td pEditableColumn>
              <p-checkbox
                [binary]="true"
                [(ngModel)]="table.addedToTable"
                [attr.name]="table.addedToTable"
                [disabled]="
                  (table.addedToTable && !table.temp_addedToTable) ||
                  (!table.searchable &&
                    techStack?.textSearch === 'Elastic Search' &&
                    activeScreen?.pageType === 'list' &&
                    activeScreen?.pageTableType !== 'QUERY_VIEW')
                "
                [ngClass]="{ readOnly: table.addedToTable && !table.temp_addedToTable }"
                [ngClass]="{
                  uncheck:
                    !table.searchable &&
                    techStack?.textSearch === 'Elastic Search' &&
                    activeScreen?.pageType === 'list' &&
                    activeScreen?.pageTableType !== 'QUERY_VIEW'
                }"
                (onChange)="handleSelectionChange($event, table, 'addedToTable')"
              >
              </p-checkbox>
            </td>
            <td>
              <span class="search-info-label">{{ populateOptionSuffix(table) }}</span>
            </td>
          </tr>
          <div *ngIf="isPopupLoader" class="loader">
            <p-progress-spinner></p-progress-spinner>
          </div>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr class="no-records">
            <td colspan="2" class="text-center">
              {{ 'NO_RECORDS_FOUND' | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div *ngIf="isPopupLoader" class="d-flex justify-content-center align-items-center w-100">
      <div class="spinners">
        <p-progress-spinner></p-progress-spinner>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <button type="button" class="btn btn-primary cancel-btn" (click)="closeAddFieldsModalDialogue()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="button" [disabled]="!canSaveWhileAddingFields" class="btn btn-primary" (click)="updateFieldsToTable()">{{ 'SAVE' | translate }}</button>
  </ng-template>
</p-dialog>

<p-dialog
  header="Add Menus"
  [(visible)]="showMenuPopup"
  [draggable]="false"
  [styleClass]="'addMenu-dialog'"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [appendTo]="'body'"
  [closable]="false"
>
  <form [formGroup]="appForm">
    <div class="form-group">
      <label for="name" class="ml-2 pl-0 col-4 col-form-label required">{{
        'COMMA_SEPARATED_MENU_ITEMS' | translate
      }}</label>
      <div class="col-sm-8">
        <input
          formControlName="name"
          id="name-list"
          type="name"
          class="form-control"
          [ngClass]="{ 'error-border': errorFlag }"
        />

        <small *ngIf="errorFlag" class="input-error-text">
          <span [innerHtml]="errorMessage"></span>
        </small>
      </div>
    </div>
    <div></div>
  </form>
  <ng-template #footer>
    <div class="text-right">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeMenuPopup()">
        {{ 'CANCEL' | translate }}
      </button>
      <button class="btn btn-primary" (click)="createFields($event, 'menu')">{{ 'SUBMIT' | translate }}</button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  header="Add Tabs"
  [(visible)]="showTabsPopup"
  [styleClass]="'addMenu-dialog'"
  [draggable]="false"
  [style]="{ width: '50vw' }"
  [modal]="true"
  [appendTo]="'body'"
>
  <form [formGroup]="appForm">
    <div class="form-group">
      <label for="name" class="ml-2 col-4 col-form-label required">{{ 'COMMA_SEPARATED_TAB_ITEMS' | translate }}</label>
      <div class="col-sm-8">
        <input
          formControlName="name"
          id="name-pane"
          type="name"
          class="form-control"
          [ngClass]="{ 'error-border': errorFlag }"
        />
        <small *ngIf="errorFlag" class="input-error-text">
          <span [innerHtml]="errorMessage"></span>
        </small>
      </div>
    </div>
    <div></div>
  </form>
  <ng-template #footer>
    <div class="text-right">
      <button type="button" class="btn btn-primary cancel-btn" (click)="closeTabsPopup()">
        {{ 'CANCEL' | translate }}
      </button>
      <button class="btn btn-primary" (click)="createFields($event, 'tab')">{{ 'SUBMIT' | translate }}</button>
    </div>
  </ng-template>
</p-dialog>

<vb-add-tab-view-dialog
  [(visible)]="showTabViewPopup"
  [tabViewTitles]="tabViewTitles"
  (tabViewCreate)="onTabViewCreate($event)"
></vb-add-tab-view-dialog>

<p-dialog
  *ngIf="showLayoutBuilder"
  header="{'CHANGE_LAYOUT' | translate}"
  [(visible)]="showLayoutBuilder"
  [style]="{ width: '90vw', height: '90vh' }"
  [modal]="true"
  appendTo="body"
>
  <vb-layout [initialData]="layoutdata" (updatedCSS)="handleCSSChangeFromGridster($event)"></vb-layout>
</p-dialog>

<vb-blocker
  [blocked]="blockedDocument"
  (refresh)="refreshActiveScreen($event)"
  [unblockAllowed]="true"
  [unblockBtnLabel]="'Refresh'"
  [message]="blockedMessage"
  [displayMessageAfter]="100"
  [positionCentered]="true"
>
</vb-blocker>
</ng-container>

<ng-container *ngIf="isShowVisualizer">
  <vb-page-visualizer [companionModeData]="originQueryParams"></vb-page-visualizer>
</ng-container>
